import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Cell,
  Legend,
} from "recharts";
import { useCommonContext } from "../../utils/context";

const AmcPieChart = () => {
  const { amcData } = useCommonContext();

  const data = [
    { name: "Total AMC", value: amcData.totalCount || 0 },
    { name: "Upcoming", value: amcData.upcomingCount || 0 },
    { name: "Renewal", value: amcData.renewalCount || 0 },
    { name: "Completed", value: amcData.completedCount || 0 },
    { name: "Expired", value: amcData.expiredCount || 0 },
  ];

  const COLORS = ["#4C6EF5", "#6C757D", "#FFBE0B", "#2EC4B6", "#E71D36"];

  return (
    <div className="p-3 bg-white rounded shadow">
      <ResponsiveContainer width="100%" height={300}>
        <BarChart
          data={data}
          barSize={40}
          margin={{ top: 20, right: 30, left: 20, bottom: 30 }}
        >
          <XAxis dataKey="name" tick={{ fontSize: 12 }} />
          <YAxis tick={{ fontSize: 12 }} />
          <Tooltip cursor={{ fill: "rgba(0, 0, 0, 0.1)" }} />
          <Legend verticalAlign="top" height={36} />

          <Bar dataKey="value" radius={[8, 8, 0, 0]}>
            {data.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={COLORS[index % COLORS.length]}
              />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>

      <div className="d-flex flex-wrap justify-content-between mt-3">
        {data.map((entry, index) => (
          <div key={index} className="d-flex align-items-center small fw-bold">
            <div
              className="rounded-circle me-2"
              style={{
                width: "12px",
                height: "12px",
                backgroundColor: COLORS[index % COLORS.length],
              }}
            />
            {entry.name}: {entry.value}
          </div>
        ))}
      </div>
    </div>
  );
};

export default AmcPieChart;
